import { render, staticRenderFns } from "./FormProducts.vue?vue&type=template&id=587a461d&scoped=true&"
import script from "./FormProducts.vue?vue&type=script&lang=js&"
export * from "./FormProducts.vue?vue&type=script&lang=js&"
import style0 from "./FormProducts.vue?vue&type=style&index=0&id=587a461d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a461d",
  null
  
)

export default component.exports